import { SvgIcon } from '@mui/material';

const Envelope = () => (
  <SvgIcon
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    sx={{ width: 24, height: 24, fill: 'none' }}
    data-testid="envelopeIcon"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.28375 5H20.7171C20.8878 5.00212 21.0564 5.03704 21.2133 5.1027C21.3702 5.16837 21.5123 5.26348 21.6315 5.38269C21.7506 5.5019 21.8446 5.64287 21.9079 5.79747C21.9712 5.95208 22.0026 6.11731 22.0004 6.28376L22.0002 17.9602C21.9665 18.262 21.8138 18.5392 21.5743 18.7333C21.3349 18.9273 21.0274 19.023 20.7169 19.0002H3.28356C2.97212 19.0273 2.66233 18.9331 2.42187 18.7383C2.18141 18.5434 2.02983 18.2637 2.00024 17.9602L2.00043 6.28376C1.99598 6.11673 2.02588 5.95052 2.08837 5.79494C2.15087 5.63937 2.24469 5.49754 2.3643 5.37788C2.48392 5.25823 2.62692 5.16314 2.78484 5.09824C2.94275 5.03334 3.11238 4.99994 3.28375 5ZM12.5637 11.4572L19.6338 6.625H4.35044L11.4359 11.4578C11.7761 11.6898 12.2237 11.6896 12.5637 11.4572ZM3.66691 8.25192V17.3752H20.3336V8.25007L12.7333 13.2887C12.5153 13.4275 12.2604 13.5009 12 13.5C11.7341 13.5031 11.4732 13.4296 11.25 13.2887L3.66691 8.25192Z"
      fill="#4D5160"
    />
  </SvgIcon>
);

export default Envelope;
